import React from "react";
import "./Main.css";

const TopSection = () => {
  return (
    <div className="platform__top-section">
      <div>
        <div className="platform__top-section-header">
          <header>
            <h3>OrderForge</h3>
            <p>
              The commerce platform Awa Digital builds and operates. Shared
              infrastructure for the products below.
            </p>
          </header>
        </div>
      </div>
    </div>
  );
};

export default TopSection;
